import React from 'react';
import { Label } from 'react-bootstrap';
import _, { find as _find, forEach as _forEach } from 'lodash';

export const isItemSalesOrder = order => {
  return order.type === 'item_sales';
};

export const isOpen = order => {
  return !order.is_closed && !order.authorization_rejected && !order.isClosed && !order.isCancelled;
};

export const getOrderIcon = order => {
  switch (order.type) {
    case 'item_sales':
      return <i className="fad fa-bags-shopping" />;
  }
};

export const getOrderLabels = (order, messages) => {
  const labels = [];
  if (order.is_rejected || (order.getIsRejected && order.getIsRejected())) {
    labels.push(
      <Label key="cancelled" class="m-r-20" style={{ fontSize: 'inherit' }}>
        {messages.rejected}
      </Label>
    );
  }

  return labels;
};

export const getCouponTypes = messages => {
  return [
    { value: 'monetary', label: messages.coupon_monetary },
    { value: 'percentage', label: messages.coupon_percentage },
  ];
};

export const getCouponTypeLabel = (value, messages) => {
  const res = _find(getCouponTypes(messages), { value });
  return (res && res.label) || '-';
};

export const getAuthorizationsList = messages => {
  return [
    { value: 'campaign_budget', label: messages.campaign.budget },
    { value: 'user_budget', label: messages.user_budget },
    { value: 'manual_vat_check', label: messages.manual_vat_check },
    { value: 'manual_data_check', label: messages.manual_data_check },
    { value: 'aws_domain_hosting', label: messages.aws_domain_hosting },
    { value: 'content_check', label: messages.content_check },
  ];
};

export const getAuthorizationLabel = (value, messages) => {
  const res = _find(getAuthorizationsList(messages), { value });
  return (res && res.label) || '-';
};

export const getOrderAuthorizationStatus = (order, type) => {
  if(!order) return false;
  if(!type) return false;

  let isAuthorized = false;

  const authList = order.getAuthorizationList();
  _forEach(authList, iteratee => {
    if (iteratee?.type === type && iteratee?.isAuthorized) {
      isAuthorized = true;
    }
  });

  return isAuthorized;
}

export const isAnyOrderItemOfType = (order, type) => {
  if(!order) return false;
  if(!type) return false;

  let hasType = false;

  const orderItems = order.getItems();
  _forEach(orderItems, iteratee => {
    if (iteratee?.code === type) {
      hasType = true;
    }
  });

  return hasType;
}

export const getAuthorizationType = (pipelineId) => {
  // pipeline types -> tasks
  let authList = [
    { value: 'campaign_budget', pipeline: 'not_defined' },
    { value: 'user_budget', pipeline: 'User Budget check' },
    { value: 'manual_vat_check', pipeline: 'Manual Reduced VAT Rate Check' },
    { value: 'manual_data_check', pipeline: 'Manual Data Check' },
    { value: 'aws_domain_hosting', pipeline: 'AWS Domain Hosting' },
    { value: 'content_check', pipeline: 'Content Check' },
    { value: 'not_defined', pipeline: 'Neue Templates' },
    { value: 'not_defined', pipeline: 'Support' },
    { value: 'not_defined', pipeline: 'CDU Wahlkampf 2021' },
    { value: 'not_defined', pipeline: 'Demo-Zugang' },
    { value: 'not_defined', pipeline: 'Zahlungseingang für Auftrag überwachen' },

  ];
  let authType = _.filter(authList, list => list.pipeline === pipelineId);
  return authType[0]?.value;
};
